import { ImageWrapper } from './ImageWrapper';
import outOfServiceImage from '../images/out-of-service.png';

export function UnavailableMessage() {
    return (
        <div className="w-full h-dvh bg-back flex items-center justify-center">
            <div className="w-[90%] max-w-[700px] h-auto text-center p-2 text-[var(--color-text)]">
                <div className="secondary-font-normal text-2xl uppercase m-1">
                    <span className="relative top-[-3px]">⚠️</span>
                    <span className="ml-[5px]">Tótem temporalmente</span>
                </div>
                <div className="secondary-font-bold text-xl uppercase m-1">No disponible</div>
                <div className="flex justify-center my-8">
                    <ImageWrapper
                        image={outOfServiceImage}
                        alt="Out of Service"
                        display="block"
                        width="300px"
                        height="auto"
                        backgroundColor="transparent"
                        margin="0"
                        padding="0"
                        borderRadius="0"
                        transition={true}
                        loadDelay={0.1}
                        onLoad={undefined}
                    />
                </div>
                <div className="secondary-font-normal text-2xl m-1">Este tótem no se encuentra operativo en este momento.</div>
                <div className="secondary-font-bold text-2xl m-1">Disculpe las molestias.</div>
            </div>
        </div>
    );
}